
import { label } from 'yet-another-react-lightbox/*';
import CommonSelect from '../../../core/common/commonSelect';
import React, { useEffect,useState } from 'react'
import useFetch from '../../../hooks/useFetch';
import { API } from '../../../common/Constants';
import { getAPIHeaders } from '../../../common/Utils';


interface Props {
    handleChange? : (value:any) => void;
    defaultDepartment?: any;
}
const DepartmentDropDown = ({handleChange, defaultDepartment}:Props) => {
    const [departments, setDepartments] = useState<any>([])
    const {isLoading, error, data, status, callFetch } = useFetch();
    
    useEffect(()=>{
        callFetch(
            API.DEPARTMENT,
            'GET',
            getAPIHeaders(),
            null,
            null
        );
     },[])

    useEffect(() => {
          if(data && status && status < 299){
            setDepartments(data.map((dept:any, idx:number)=>{
                return {
                    value: dept?.id,
                    label: dept?.name
                }
            }));
          }
     }, [status]);
    
    return (
            <CommonSelect
                className='select'
                options={departments}
                defaultValue={defaultDepartment}
                onChange={handleChange}
                disabled={isLoading}
          />
    )
}

export default DepartmentDropDown